import { DataBaseModelInterface } from '@solcre-org/core';
import { ClientModel } from './client.model';
import { QuoteModel } from './quote.model';

export class ClientQuotesResponseModel implements DataBaseModelInterface {
  constructor(
    public quotes: QuoteModel[] = [],
    public totalItems: number = 0,
    public client?: ClientModel
  ) {}

  public fromJSON(json: any): ClientQuotesResponseModel {
    if (json) {
      this.quotes = new QuoteModel().fromJSONList(json.contacts || []);
      this.totalItems = json.totalItems || 0;
      this.client = json.client ? new ClientModel().fromJSON(json.client) : undefined;
    }
    return this;
  }

  public fromJSONList(json: any): ClientQuotesResponseModel[] {
    if (json) {
      return json.map((element: any) => new ClientQuotesResponseModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      contacts: this.quotes.map(quote => quote.toJSON()),
      totalItems: this.totalItems,
      client: this.client ? this.client.toJSON() : undefined,
    };
  }

  public getId() {
    return this.client?.getId() ?? '';
  }

  public getReference() {
    return this.client?.getReference() ?? '';
  }
}